import styled from 'styled-components'

export const ErrorWrap = styled.span `
    display: inline-block;
    color: red;
    margin-top: 5px;
`;